import { storageKeys } from '@/shared/consts/storageKeys'
import {
  deletFromSessionStorage,
  getFromSessionStorage,
  setInSessionStorage
} from './storageHelpers'

const _isDoraSource = (params: URLSearchParams) => {
  const isDoraCampaign = [
    'dora_automatizada',
    'dora_automatizada_naologado'
  ].includes(params.get('utm_campaign') as string)

  const hasDoraIntegrationId = params.has('sessionId')

  return isDoraCampaign && hasDoraIntegrationId
}

export const hasDoraIntegrationId = () => {
  return (
    getFromSessionStorage(storageKeys.doraIntegrationId) !== null ||
    getFromSessionStorage(storageKeys.doraIntegrationIdNaoLogado) !== null
  )
}

export const getDoraIntegrationId = () => {
  return getFromSessionStorage(storageKeys.doraIntegrationId) || undefined
}

export const removeDoraIntegrationId = () => {
  deletFromSessionStorage(storageKeys.doraIntegrationId)
}

export const startAutomatedDoraService = (params: URLSearchParams) => {
  if (!_isDoraSource(params)) {
    return
  }

  const doraIntegrationId = params.get('sessionId') || ''

  setInSessionStorage(storageKeys.doraIntegrationId, doraIntegrationId)
}
